<div
  class="flex gap-2 overflow-x-auto pb-1 sm:overflow-x-visible sm:pb-0"
  role="tablist"
  aria-label="Import source"
  data-testid="source-picker"
>
  @for (opt of options; track opt.value) {
    <button
      type="button"
      role="tab"
      [attr.aria-selected]="isActive(opt.value)"
      [attr.data-source]="opt.value"
      [disabled]="isDisabled(opt.value)"
      [attr.title]="isDisabled(opt.value) ? 'BibTeX import is not supported yet' : null"
      (click)="pick(opt.value)"
      class="flex-shrink-0 whitespace-nowrap rounded-full border px-3 py-1.5 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-40"
      [class.bg-secondary]="isActive(opt.value)"
      [class.text-white]="isActive(opt.value)"
      [class.border-secondary]="isActive(opt.value)"
      [class.bg-white]="!isActive(opt.value)"
      [class.text-slate-700]="!isActive(opt.value)"
      [class.border-slate-200]="!isActive(opt.value)"
      [class.hover:bg-slate-50]="!isActive(opt.value)"
    >
      {{ opt.label }}
      @if (isDisabled(opt.value)) {
        <span class="ml-1 text-xs">(soon)</span>
      }
    </button>
  }
</div>
